import { render, staticRenderFns } from "./inboxBubble.vue?vue&type=template&id=5e5aca90&"
import script from "./inboxBubble.vue?vue&type=script&lang=js&"
export * from "./inboxBubble.vue?vue&type=script&lang=js&"
import style0 from "./inboxBubble.vue?vue&type=style&index=0&id=5e5aca90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports